module.exports = __webpack_public_path__ + "static/Gilroy-Bold-961e253b03eb0db4b5dcc01e1426910d.woff2";